import React from 'react'

import { StyledSpinner as S } from './Spinner.styles'

type TProps = {
  isFullScreen?: boolean
  height?: number
}

export const Svg: React.FC<Omit<TProps, 'isFullScreen'>> = ({ height }) => (
  <S.Svg
    height={height}
    viewBox="0 0 100 100"
    xmlns="http://www.w3.org/2000/svg"
    preserveAspectRatio="xMidYMid"
  >
    <S.Circle
      cx="50"
      cy="50"
      fill="none"
      r="36"
      strokeWidth="7"
      stroke="#189cf3"
      strokeDasharray="169.646 58.549"
      strokeLinecap="round"
    />
  </S.Svg>
)

export const Spinner: React.FC<TProps> = ({
  isFullScreen = true,
  height = 76,
}) =>
  isFullScreen ? (
    <S.Wrapper>
      <Svg height={height} />
    </S.Wrapper>
  ) : (
    <Svg height={height} />
  )
